import React from "react";
export default function JSONLD(_ref) {
  var JSONLD = _ref.JSONLD;
  return React.createElement("script", {
    type: "application/ld+json",
    dangerouslySetInnerHTML: {
      __html: JSON.stringify(JSONLD)
    }
  });
}